import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-detail-bool',
  templateUrl: './detail-bool.component.html',
  styleUrls: ['./detail-bool.component.scss']
})
export class DetailBoolComponent {
  @Input() header?: string;
  @Input() value?: boolean;
}
